var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import { Stage } from "ngl";

var Viztein = function (_React$PureComponent) {
  _inherits(Viztein, _React$PureComponent);

  function Viztein() {
    _classCallCheck(this, Viztein);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Viztein.prototype.addProteinToViewport = function addProteinToViewport(stage, protein) {
    if (!protein.config) {
      stage.loadFile(protein.filename, { defaultRepresentation: true });
    } else {
      stage.loadFile(protein.filename).then(function (stageObj) {
        protein.config.forEach(function (configItem) {
          if (Array.isArray(configItem.input)) {
            stageObj[configItem.type].apply(stageObj, configItem.input);
          } else {
            stageObj[configItem.type](configItem.input);
          }
        });

        if (!protein.config.some(function (configItem) {
          return configItem.type === "autoView";
        })) {
          stageObj.autoView();
        }
      });
    }
  };

  Viztein.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        data = _props.data,
        viewportId = _props.viewportId,
        viewportStyle = _props.viewportStyle;

    var stage = new Stage(viewportId, {
      backgroundColor: viewportStyle.backgroundColor
    });

    // data can be a single object or array of objects
    if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object") {
      this.addProteinToViewport(stage, data);
    } else {
      data.forEach(function (protein) {
        _this2.addProteinToViewport(stage, protein);
      });
    }
  };

  Viztein.prototype.render = function render() {
    var _props2 = this.props,
        viewportId = _props2.viewportId,
        viewportStyle = _props2.viewportStyle;


    return React.createElement("div", { id: viewportId, style: viewportStyle });
  };

  return Viztein;
}(React.PureComponent);

Viztein.defaultProps = {
  viewportId: "viewport",
  viewportStyle: {
    backgroundColor: "black",
    width: "500px",
    height: "500px"
  }
};

export default Viztein;